module.exports = __webpack_public_path__ + "static/img/Payment_Success_Order.af5ce3b8.png";